import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from './styles';

const NotFound = () => (
  <Container>
    <h1>Página não encontrada.</h1>
    <Link to="/admin/dashboard">Voltar para página inicial</Link>
  </Container>
);
export default NotFound;



// WEBPACK FOOTER //
// ./src/admin/pages/NotFound/index.js